import Form from 'src/utils/Form.js'

class Currency extends Form {
  constructor(data, config = null) {
    super(data, config || Form.config)
  }

  fetch(then) {
    return super.get(`currencies/${this.acronym}/edit`).then(data => {
      this.originalData = data
      for (let field in this.originalData) {
        this[field] = data[field]
      }
      then(data)
    })
  }

  static all(parameters, then) {
    return new Form().get(`currencies?${parameters}`).then(then)
  }

  create(then) {
    return super.post('currencies').then(then)
  }

  update(then) {
      return super.put(`currencies/${this.acronym}`).then(then)
  }

  destroy(then) {
      return super.delete(`currencies/${this.acronym}`).then(then)
  }
}

export default Currency
